enum CommandType {
  SnapshotRequested = "snapshot-requested",
  SnapshotTaken = "snapshot-taken",
  SnapshotFailed = "snapshot-failed",
  SnapshotUploaded = "snapshot-uploaded",
  LaserPointer = "laser-pointer",
  Backgrounded = "backgrounded",
  VisitorRejected = "visitor-rejected",
  VisitorEjected = "visitor-ejected",
  Unbackgrounded = "unbackgrounded",
  Ping = "ping",
  ScreenshareStarted = "screenshare-started",
  SetParticipantOnCanvasMode = "set-participant-on-canvas-mode",
  setUserCameraCount = "set-user-camera-count",
  LaserPointerStateNotification = "laser-pointer-state-notification",
  CameraFlipRequested = "camera-flip-requested",
  CameraFlipAccepted = "camera-flip-accepted",
  CameraFlipSuccess = "camera-flip-success",
  CameraFlipDenied = "camera-flip-denied",
  CameraFlipFailed = "camera-flip-failed",
  CameraFlipTimeout = "camera-flip-timeout",
}
type CommandPayload = {
	senderId: string;
    senderName?: string;
    id: string;
    timestamp: number;
	commandType: CommandType;
}

type LaserPointerPayload = CommandPayload & {
    targetUserId: string;
    x: number;
    y: number;
}


type LaserPointerStateNotificationPayload = CommandPayload & {
    isActive: boolean;
    drawingUserId: string;
    targetUserId: string;
}

type SetParticipantOnCanvasModePayload = CommandPayload & {
    targetUserId: string;
    isOnCanvasMode: boolean;
}

type setUserCameraCountPayload = CommandPayload & {
  cameraCount: number;
};

type CameraFlipRequestPayload = CommandPayload & {
    targetUserId: string;
}

type CameraFlipResponsePayload = CommandPayload & {
    requestId: string;
    targetUserId: string;
}

export type {
  CommandPayload,
  LaserPointerPayload,
  LaserPointerStateNotificationPayload,
  SetParticipantOnCanvasModePayload,
  setUserCameraCountPayload,
  CameraFlipRequestPayload,
  CameraFlipResponsePayload,
};
export { CommandType };